import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0b57dabc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "head"
};
const _hoisted_3 = {
  style: {
    "width": "100%",
    "display": "grid",
    "grid-template-columns": "repeat(3, minmax(0, 1fr))",
    "gap": "1rem"
  }
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "head--box__title"
}, "开通用户数", -1));
const _hoisted_5 = {
  class: "head--box__num"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "head--box__title"
}, "在线用户数", -1));
const _hoisted_7 = {
  class: "head--box__num"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "head--box__title"
}, "当天请求次数", -1));
const _hoisted_9 = {
  class: "head--box__num"
};
const _hoisted_10 = {
  class: "body"
};
const _hoisted_11 = {
  class: "project"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "project-top"
}, "应用", -1));
const _hoisted_13 = {
  key: 0,
  class: "project-contain"
};
const _hoisted_14 = {
  class: "project-title"
};
const _hoisted_15 = {
  class: "amount"
};
const _hoisted_16 = {
  class: "date"
};
const _hoisted_17 = {
  class: "project-title"
};
const _hoisted_18 = {
  class: "amount"
};
const _hoisted_19 = {
  class: "date"
};
const _hoisted_20 = {
  class: "project-title"
};
const _hoisted_21 = {
  class: "amount"
};
const _hoisted_22 = {
  class: "date"
};
const _hoisted_23 = {
  class: "project-title"
};
const _hoisted_24 = {
  class: "amount"
};
const _hoisted_25 = {
  class: "date"
};
const _hoisted_26 = {
  class: "project-title"
};
const _hoisted_27 = {
  class: "amount"
};
const _hoisted_28 = {
  class: "date"
};
const _hoisted_29 = {
  class: "project-title"
};
const _hoisted_30 = {
  class: "amount"
};
const _hoisted_31 = {
  class: "date"
};
const _hoisted_32 = {
  class: "navigation"
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "navgation-top"
}, "快捷导航", -1));
const _hoisted_34 = {
  class: "navgation-contain"
};
const _hoisted_35 = ["onClick"];
import { getworkTableData } from '@/api/workTable';
import { Icon } from '@iconify/vue';
import { watch, ref } from 'vue';
import { useRouter } from 'vue-router';
import { navigationData } from './config';
import { getApplinkStatistics } from '@/api/sys';
export default {
  __name: 'index',
  setup(__props) {
    const data = ref(); // 工作台数据
    const router = useRouter();
    const currentDate = ref(new Date().toJSON().slice(0, 10));
    // 跳转至待审核
    const goAwait = e => {
      router.push({
        path: '/application/approval',
        query: {
          tab: e,
          isWait: true
        }
      });
    };
    // 跳转至即将过期
    const goExpire = e => {
      router.push({
        path: '/application/expire',
        query: {
          tab: e
        }
      });
    };
    // 导航跳转
    const goNavgation = path => {
      router.push({
        path
      });
    };
    // 获取工作台数据
    const getData = async () => {
      const res = await getworkTableData();
      data.value = res;
    };
    getData();
    // 每次路由进入主页重新获取数据
    watch(() => router.currentRoute.value.path, toPath => {
      if (toPath === '/home') {
        getData();
      }
    }, {
      immediate: true,
      deep: true
    });
    const handleToApplinkClinic = (e, isOnline) => {
      router.push(`/appLinkClinic?isOnline=${isOnline}`);
    };
    const handleToApplinkLog = () => {
      router.push('/appLinkLog');
    };
    const statistics = ref({
      clinicCount: 0,
      onlineCount: 0,
      requestCount: 0
    });
    const _getApplinkStatistics = () => {
      getApplinkStatistics().then(res => {
        console.log(res);
        statistics.value = res;
      });
    };
    _getApplinkStatistics();
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
        class: "head--box",
        onClick: _cache[0] || (_cache[0] = e => handleToApplinkClinic(e, false))
      }, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("span", null, _toDisplayString(statistics.value.clinicCount), 1), _createVNode(_unref(Icon), {
        style: {
          "font-size": "28px"
        },
        icon: "icon-park-outline:announcement"
      })])]), _createElementVNode("div", {
        class: "head--box",
        onClick: _cache[1] || (_cache[1] = e => handleToApplinkClinic(e, true))
      }, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_createElementVNode("span", null, _toDisplayString(statistics.value.onlineCount), 1), _createVNode(_unref(Icon), {
        style: {
          "font-size": "28px"
        },
        icon: "icon-park-outline:box"
      })])]), _createElementVNode("div", {
        class: "head--box",
        onClick: handleToApplinkLog
      }, [_hoisted_8, _createElementVNode("div", _hoisted_9, [_createElementVNode("span", null, _toDisplayString(statistics.value.requestCount), 1), _createVNode(_unref(Icon), {
        style: {
          "font-size": "28px"
        },
        icon: "icon-park-outline:data-file"
      })])])])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_hoisted_12, data.value ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", {
        class: "project-item",
        onClick: _cache[2] || (_cache[2] = $event => goAwait(3))
      }, [_createElementVNode("div", _hoisted_14, [_createVNode(_unref(Icon), {
        icon: `icon-park-outline:application-effect`,
        style: {
          "font-size": "30px",
          "margin-right": "20px",
          "color": "#09d9ff"
        }
      }), _createTextVNode(" AI应用待审批 ")]), _createElementVNode("div", _hoisted_15, "待审批数量: " + _toDisplayString(data.value.donglePendApprovalCount), 1), _createElementVNode("div", _hoisted_16, _toDisplayString(currentDate.value), 1)]), _createElementVNode("div", {
        class: "project-item",
        onClick: _cache[3] || (_cache[3] = $event => goAwait(1))
      }, [_createElementVNode("div", _hoisted_17, [_createVNode(_unref(Icon), {
        icon: `icon-park-outline:application-two`,
        style: {
          "font-size": "30px",
          "margin-right": "20px",
          "color": "#09d9ff"
        }
      }), _createTextVNode(" 小程序待审批 ")]), _createElementVNode("div", _hoisted_18, "待审批数量: " + _toDisplayString(data.value.smallProgramPendApprovalCount), 1), _createElementVNode("div", _hoisted_19, _toDisplayString(currentDate.value), 1)]), _createElementVNode("div", {
        class: "project-item",
        onClick: _cache[4] || (_cache[4] = $event => goAwait(2))
      }, [_createElementVNode("div", _hoisted_20, [_createVNode(_unref(Icon), {
        icon: `icon-park-outline:application-one`,
        style: {
          "font-size": "30px",
          "margin-right": "20px",
          "color": "#09d9ff"
        }
      }), _createTextVNode(" Web应用待审批 ")]), _createElementVNode("div", _hoisted_21, "待审批数量: " + _toDisplayString(data.value.webPendApprovalCount), 1), _createElementVNode("div", _hoisted_22, _toDisplayString(currentDate.value), 1)]), _createElementVNode("div", {
        class: "project-item",
        onClick: _cache[5] || (_cache[5] = $event => goExpire(3))
      }, [_createElementVNode("div", _hoisted_23, [_createVNode(_unref(Icon), {
        icon: `icon-park-outline:application-effect`,
        style: {
          "font-size": "30px",
          "margin-right": "20px",
          "color": "red"
        }
      }), _createTextVNode(" AI应用即将过期 ")]), _createElementVNode("div", _hoisted_24, "即将过期数量: " + _toDisplayString(data.value.dongleRecentExpireCount), 1), _createElementVNode("div", _hoisted_25, _toDisplayString(currentDate.value), 1)]), _createElementVNode("div", {
        class: "project-item",
        onClick: _cache[6] || (_cache[6] = $event => goExpire(1))
      }, [_createElementVNode("div", _hoisted_26, [_createVNode(_unref(Icon), {
        icon: `icon-park-outline:application-two`,
        style: {
          "font-size": "30px",
          "margin-right": "20px",
          "color": "red"
        }
      }), _createTextVNode(" 小程序即将过期 ")]), _createElementVNode("div", _hoisted_27, "即将过期数量: " + _toDisplayString(data.value.smallProgramRecentExpireCount), 1), _createElementVNode("div", _hoisted_28, _toDisplayString(currentDate.value), 1)]), _createElementVNode("div", {
        class: "project-item",
        onClick: _cache[7] || (_cache[7] = $event => goExpire(2))
      }, [_createElementVNode("div", _hoisted_29, [_createVNode(_unref(Icon), {
        icon: `icon-park-outline:application-one`,
        style: {
          "font-size": "30px",
          "margin-right": "20px",
          "color": "red"
        }
      }), _createTextVNode(" Web应用即将过期 ")]), _createElementVNode("div", _hoisted_30, "即将过期数量: " + _toDisplayString(data.value.webRecentExpireCount), 1), _createElementVNode("div", _hoisted_31, _toDisplayString(currentDate.value), 1)])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_32, [_hoisted_33, _createElementVNode("div", _hoisted_34, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navigationData), item => {
        return _openBlock(), _createElementBlock("div", {
          class: "navgation-item",
          key: item,
          onClick: $event => goNavgation(item.path)
        }, [_createVNode(_unref(Icon), {
          icon: `icon-park-outline:${item.icon}`,
          style: _normalizeStyle({
            'font-size': '25px',
            color: item.color
          })
        }, null, 8, ["icon", "style"]), _createTextVNode(" " + _toDisplayString(item.name), 1)], 8, _hoisted_35);
      }), 128))])])])]);
    };
  }
};